"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[32288],{

/***/ 32288:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(97582);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var stores_settings__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31806);
/* harmony import */ var components_FormatDate__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(87936);
/* harmony import */ var components_modal_MaterialModal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81268);
/* harmony import */ var _material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(17812);
/* harmony import */ var _material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(80366);
/* harmony import */ var components_Alert__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34950);
/* harmony import */ var components_ProjectFirestore__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(79794);
/* harmony import */ var components_ProjectStorage__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8522);
/* harmony import */ var _material_ui_icons_Create__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(74540);
/* harmony import */ var _material_ui_icons_CheckCircleOutline__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(23059);
/* harmony import */ var _material_ui_icons_HighlightOff__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(35736);
/* harmony import */ var _material_ui_core_TextField__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(33426);
/* harmony import */ var components_modal_DeleteModal__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99907);






// import Modal from "@material-ui/core/Modal";
// import ModalFade from "components/modal/ModalFade";


// import Backdrop from "@material-ui/core/Backdrop";

// import { makeStyles } from "@material-ui/core/styles";








// const useStyles = makeStyles({
//   modal: {
//     outline: 0, // add / remove
//   },
// });
/* 데이터 분석 앱 카드 */ var DataAnalysisAppCard = function(param) {
    var id = param.id, review = param.review, reviewedAt = param.reviewedAt, updateData = param.updateData, setUpdateData = param.setUpdateData, inputFile = param.inputFile, outputFile = param.outputFile, appId = param.appId, email = param.email, appName = param.appName, price = param.price, createdAt = param.createdAt, inputType = param.inputType, category = param.category;
    var linkDownload = /** 파일 다운로드 */ function linkDownload(filename, content) {
        var link = document.createElement("a");
        var contentType = "data:application/csv;charset=utf-8,";
        var uriContent = contentType + encodeURIComponent(content);
        link.setAttribute("href", uriContent);
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    if (!id) return "실행 결과가 없습니다.";
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), modalVisible = ref[0], setModalVisible = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), modalVisible2 = ref1[0], setModalVisible2 = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), getUrl = ref2[0], setGetUrl = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), downloadFileData = ref3[0], setDownloadFileData = ref3[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
        var storageFileRef;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
            if (outputFile && category === "dataAnalysis") {
                storageFileRef = components_ProjectStorage__WEBPACK_IMPORTED_MODULE_6__/* .projectStorage.ref */ .v.ref(outputFile);
                storageFileRef.getDownloadURL().then(function(url) {
                    setGetUrl(url);
                }).catch(function(error) {
                    ;
                });
            }
            return [
                2
            ];
        });
    }), []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
        var res, result, rows, columnString, fieldString, column, field, tempDownloadFileData;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!getUrl) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        fetch(getUrl)
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        4,
                        res.text()
                    ];
                case 2:
                    result = _state.sent();
                    if (result !== "" && result.indexOf("<!DOCTYPE html><html><head>") === -1) {
                        rows = result.split("\n");
                        columnString = rows[0];
                        fieldString = rows[1];
                        column = columnString.replace(/(\")/g, "").split(",");
                        field = fieldString.replace(/(\")/g, "").split(",");
                        tempDownloadFileData = "";
                        column.map(function(m) {
                            return tempDownloadFileData += m + ",";
                        });
                        tempDownloadFileData = tempDownloadFileData.substring(0, tempDownloadFileData.length - 1);
                        tempDownloadFileData += "\n";
                        field.map(function(m) {
                            return tempDownloadFileData += m + ",";
                        });
                        tempDownloadFileData = tempDownloadFileData.substring(0, tempDownloadFileData.length - 1);
                        setDownloadFileData(tempDownloadFileData);
                    }
                    _state.label = 3;
                case 3:
                    return [
                        2
                    ];
            }
        });
    }), [
        getUrl
    ]);
    /* 실행 결과 삭제 */ var handleFileDelete = function() {
        setModalVisible2(true);
    };
    /* 후기 내용 추가 */ var handleReviewModal = function() {
        setModalVisible(true);
    };
    /* 결과 파일 다운로드 */ var handleFileDownload = function() {
        var fileName = "".concat(appName, "_").concat(createdAt, ".csv");
        linkDownload(fileName, downloadFileData);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "app-content mt-4",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "aiso-card aiso-shadow",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "cursor-pointer",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "p-3",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "truncate-1-lines text-333 text-base font-gmarket-medium font-bold my-2",
                                    children: appName
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "px-3",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                        className: "text-ss text-333 font-gmarket-medium",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "font-bold text-sm text-primary",
                                                children: price
                                            }),
                                            " Credit"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "mb-0 text-aaa font-gmarket-medium text-xs",
                                        children: createdAt
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "px-3 pt-3",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                            type: "",
                            className: "btn text-xs font-bold px-3 py-2",
                            onClick: handleFileDownload,
                            children: "결과 다운로드"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex items-center justify-between pt-3",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "w-full flex",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    className: "btn w-1/2 font-bold text-xs",
                                    onClick: handleReviewModal,
                                    type: "",
                                    children: reviewedAt ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_CheckCircleOutline__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                className: "mr-2"
                                            }),
                                            " 작성 완료"
                                        ]
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_Create__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                className: "mr-2"
                                            }),
                                            " 후기 작성"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                    className: "btn w-1/2 font-bold text-xs",
                                    onClick: handleFileDelete,
                                    type: "",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_HighlightOff__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                            className: "mr-2"
                                        }),
                                        " 삭제"
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DeleteModalContent, {
                modalVisible: modalVisible2,
                setModalVisible: setModalVisible2,
                docId: id,
                appEmail: email,
                appId: appId,
                reviewedAt: reviewedAt,
                updateData: updateData,
                setUpdateData: setUpdateData
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ReviewContentModal, {
                modalVisible: modalVisible,
                setModalVisible: setModalVisible,
                closeModal: function() {
                    return setModalVisible(false);
                },
                id: id,
                email: email,
                review: review,
                reviewedAt: reviewedAt,
                updateData: updateData,
                setUpdateData: setUpdateData,
                appId: appId,
                appName: appName,
                inputFile: inputFile,
                outputFile: outputFile,
                inputType: inputType
            })
        ]
    });
};
/* 후기 등록 */ var ReviewContentModal = function(param) {
    var modalVisible = param.modalVisible, setModalVisible = param.setModalVisible, closeModal = param.closeModal, id = param.id, email = param.email, review = param.review, reviewedAt = param.reviewedAt, updateData = param.updateData, setUpdateData = param.setUpdateData, appId = param.appId, appName = param.appName, inputFile = param.inputFile, outputFile = param.outputFile, inputType = param.inputType;
    var settings = (0,stores_settings__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    // const styles = useStyles();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), imageVisible = ref[0], setImageVisible = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), reviewContent = ref1[0], setReviewContent = ref1[1];
    var handleModalOkButton = function() {
        if (!reviewContent || reviewContent === "") {
            var text = "후기 내용을 입력해주세요.";
            (0,components_Alert__WEBPACK_IMPORTED_MODULE_4__/* .BasicAlert */ .N)(text);
            return "";
        }
        handleReviewSave();
    };
    var handleReviewSave = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function() {
            var date, createdAt, updateValues, _tmp, docRef, _tmp1, error, newValues, _tmp2, docRef1, error1, docRef2, error2;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        date = new Date();
                        createdAt = (0,components_FormatDate__WEBPACK_IMPORTED_MODULE_13__/* .FormatDate */ .r2)(date);
                        /**
     * 1. contentsData update
     * 2. users 아래 후기 내용 저장
     * 3. 사용된 앱 아래 기록
     * 4. 앱 개발자 아래 기록
     */ /* 1. 테이블 데이터 업데이트 */ setUpdateData(!updateData);
                        _tmp = {};
                        updateValues = (_tmp.review = reviewContent, _tmp.reviewedAt = createdAt, _tmp.imageVisible = imageVisible, _tmp.visible = true, _tmp);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        docRef = components_ProjectFirestore__WEBPACK_IMPORTED_MODULE_5__/* .projectFirestore.collection */ .H.collection("users").doc("".concat(settings.email)).collection("history").doc("".concat(id));
                        _tmp1 = {};
                        return [
                            4,
                            docRef.set(updateValues, (_tmp1.merge = true, _tmp1))
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 4:
                        _tmp2 = {};
                        newValues = (_tmp2.email = settings.email, _tmp2.userName = settings.name, _tmp2.appId = appId, _tmp2.appName = appName, _tmp2.review = reviewContent, _tmp2.createdAt = createdAt, _tmp2.comment = "", _tmp2.commentedAt = "", _tmp2.inputFile = inputFile, _tmp2.outputFile = outputFile, _tmp2.imageVisible = imageVisible, _tmp2.visible = true, _tmp2);
                        _state.label = 5;
                    case 5:
                        _state.trys.push([
                            5,
                            7,
                            ,
                            8
                        ]);
                        docRef1 = components_ProjectFirestore__WEBPACK_IMPORTED_MODULE_5__/* .projectFirestore.collection */ .H.collection("gcf").doc("".concat(email)).collection("app").doc("".concat(appId)).collection("review").doc(id);
                        return [
                            4,
                            docRef1.set(newValues)
                        ];
                    case 6:
                        _state.sent();
                        return [
                            3,
                            8
                        ];
                    case 7:
                        error1 = _state.sent();
                        return [
                            3,
                            8
                        ];
                    case 8:
                        _state.trys.push([
                            8,
                            10,
                            ,
                            11
                        ]);
                        docRef2 = components_ProjectFirestore__WEBPACK_IMPORTED_MODULE_5__/* .projectFirestore.collection */ .H.collection("users").doc("".concat(email)).collection("review").doc("".concat(id));
                        return [
                            4,
                            docRef2.set(newValues)
                        ];
                    case 9:
                        _state.sent();
                        return [
                            3,
                            11
                        ];
                    case 10:
                        error2 = _state.sent();
                        return [
                            3,
                            11
                        ];
                    case 11:
                        setModalVisible(false);
                        setReviewContent("");
                        return [
                            2
                        ];
                }
            });
        });
        return function handleReviewSave() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_modal_MaterialModal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        open: modalVisible,
        closeModal: closeModal,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "popup-content m-0 modal-width-180",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "popup-header",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                        "aria-label": "close",
                        className: "w-15 h-15",
                        onClick: closeModal,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_icons_Close__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {})
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "popup-body flex flex-col justify-center items-center",
                    children: reviewedAt ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                className: "text-333 font-gmarket-medium text-2xl font-bold center mb-4",
                                children: "후기 내용"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "popup-body flex flex-col justify-center items-start",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "w-full mt-3",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            children: review
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "w-full text-aaa mt-3",
                                        children: reviewedAt
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "popup-footer center"
                            })
                        ]
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "popup-body flex flex-col justify-center items-start",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h5", {
                                        className: "text-333 font-gmarket-medium text-2xl mb-0 font-bold",
                                        children: "후기 작성"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "w-full",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_TextField__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                            // label="후기 내용"
                                            placeholder: "앱 실행 후기를 작성해주세요.",
                                            fullWidth: true,
                                            value: reviewContent,
                                            onChange: function(e) {
                                                return setReviewContent(e.target.value);
                                            },
                                            multiline: true,
                                            rows: 5,
                                            className: "mt-4 w-full",
                                            InputLabelProps: {
                                                shrink: true
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "text-888 mb-0 py-3",
                                        children: "등록 후 후기 내용은 변경할 수 없습니다."
                                    }),
                                    inputType && inputType === "csv" ? "" : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "form-check",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                            className: "form-check-label",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                    type: "checkbox",
                                                    className: "form-check-input",
                                                    onChange: function() {
                                                        return setImageVisible(!imageVisible);
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                    className: "input-helper",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        style: {
                                                            fontStyle: "normal"
                                                        },
                                                        children: "이미지 첨부 허용"
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "popup-footer center",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    type: "button",
                                    className: "btn btn-modal-o font-bold whitespace-nowrap",
                                    onClick: function() {
                                        return handleModalOkButton();
                                    },
                                    children: "후기 등록"
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* 삭제 모달 */ var DeleteModalContent = function(param) {
    var modalVisible = param.modalVisible, setModalVisible = param.setModalVisible, docId = param.docId, appEmail = param.appEmail, appId = param.appId, reviewedAt = param.reviewedAt, updateData = param.updateData, setUpdateData = param.setUpdateData;
    var settings = (0,stores_settings__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    var handleResultRemove = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(docId) {
            var docRef, docRefDeveloper, docRefApp, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            5,
                            ,
                            6
                        ]);
                        docRef = components_ProjectFirestore__WEBPACK_IMPORTED_MODULE_5__/* .projectFirestore.collection */ .H.collection("users").doc(settings.email).collection("history").doc(docId);
                        return [
                            4,
                            docRef.delete()
                        ];
                    case 1:
                        _state.sent();
                        if (!(reviewedAt !== "")) return [
                            3,
                            4
                        ];
                        docRefDeveloper = components_ProjectFirestore__WEBPACK_IMPORTED_MODULE_5__/* .projectFirestore.collection */ .H.collection("users").doc(appEmail).collection("review").doc(docId);
                        docRefApp = components_ProjectFirestore__WEBPACK_IMPORTED_MODULE_5__/* .projectFirestore.collection */ .H.collection("gcf").doc(appEmail).collection("app").doc(appId).collection("review").doc(docId);
                        return [
                            4,
                            docRefDeveloper.delete()
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            docRefApp.delete()
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        /* 1. 테이블 데이터 업데이트 */ setUpdateData(!updateData);
                        setModalVisible(false);
                        return [
                            3,
                            6
                        ];
                    case 5:
                        error = _state.sent();
                        (0,components_Alert__WEBPACK_IMPORTED_MODULE_4__/* .BasicAlert */ .N)("답변 에러");
                        return [
                            3,
                            6
                        ];
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleResultRemove(docId) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_modal_DeleteModal__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        modalVisible: modalVisible,
        closeModal: function() {
            return setModalVisible(false);
        },
        handleDeleteOkModal: function() {
            return handleResultRemove(docId);
        },
        target: "결과를"
    });
};
/* harmony default export */ __webpack_exports__["default"] = (DataAnalysisAppCard);


/***/ })

}]);